import styled from 'styled-components';

const DropdownDivider = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30039493__sc-1i1gohs-0"
})(["content:\"\";border-bottom:1px solid ", ";margin:", " 0;"], ({
  theme
}) => theme.dropdown.submenuBorderColor, ({
  theme
}) => theme.spacing.mini);
DropdownDivider.displayName = 'DropdownDivider';
var DropdownDivider$1 = DropdownDivider;

export { DropdownDivider$1 as D };
//# sourceMappingURL=DropdownDivider-b6c4ac0c.js.map
